//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeatureList.js";
import "../no/Expression.js";
import "../Features/Features.AECDesign.RebarHookBlockBuilder.js";
import "../Features/Features.AECDesign.RebarLimitBuilder.js";
import "../Features/Features.AECDesign.MaterialSectionBuilder.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CrossingRebarsFeature",0,"Features.SelectFeatureList",0],[1,"Diameter",0,"Expression",0],[1,"EndFacesThickness",0,"Expression",0],[1,"EndHook",0,"Features.AECDesign.RebarHookBlockBuilder",0],[1,"EndLimit",0,"Features.AECDesign.RebarLimitBuilder",0],[1,"MaterialSection",0,"Features.AECDesign.MaterialSectionBuilder",0],[0,"NumberOfRebars",1,0],[0,"PatternSetting",1,0],[0,"PlacementMethod",1,0],[0,"SelectEdge",0,"ScCollector",0],[1,"SpecifyPoint",0,"Section",0],[1,"StartFace",0,"ScCollector",0],[1,"StartFacesThickness",0,"Expression",0],[1,"StartHook",0,"Features.AECDesign.RebarHookBlockBuilder",0],[1,"StartLimit",0,"Features.AECDesign.RebarLimitBuilder",0]],[[[],"AlternateSolution",{},0,0],[[],"UpdateReferencedRebarBodies",{},0,0]],[]];
SPLM.Features.AECDesign.LongitudinalRebarsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.LongitudinalRebarsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;